import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import blogBanner from "../assets/images/page-titles/12.webp";
import blog1 from "../assets/images/blog/grid/1.webp";
import blog2 from "../assets/images/blog/grid/2.webp";
import blog3 from "../assets/images/blog/grid/3.webp";
import blog4 from "../assets/images/blog/grid/4.webp";
import blog5 from "../assets/images/blog/grid/5.webp";
import blog6 from "../assets/images/blog/grid/6.webp";

function Blogs() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Get API configuration
  const api_url =
    localStorage.getItem("api_url") || "http://localhost/inscape_backend/api/";

  // Default fallback blog images
  const fallbackImages = [blog1, blog2, blog3, blog4, blog5, blog6];

  // Default static blog posts (fallback)
  const defaultBlogPosts = [
    {
      blog_id: 1,
      blog_image_url: blog1,
      blog_tags: "Business, Consumers",
      blog_title:
        "Empowered consumers are prepared to make changes response to disruptions!",
      blog_short_txt:
        "Global uncertainties and supply chain issues are also leading many consumers to look more to their home markets. Eight in ten respondents expressed a willingness to pay a higher average price for products produced locally or domestically.",
      c_date: "2025-01-30",
    },
    {
      blog_id: 2,
      blog_image_url: blog2,
      blog_tags: "Business, Consumers",
      blog_title:
        "Empowered consumers are prepared to make changes response to disruptions!",
      blog_short_txt:
        "Global uncertainties and supply chain issues are also leading many consumers to look more to their home markets. Eight in ten respondents expressed a willingness to pay a higher average price for products produced locally or domestically.",
      c_date: "2025-01-30",
    },
    {
      blog_id: 3,
      blog_image_url: blog3,
      blog_tags: "Business, Consumers",
      blog_title:
        "Empowered consumers are prepared to make changes response to disruptions!",
      blog_short_txt:
        "Global uncertainties and supply chain issues are also leading many consumers to look more to their home markets. Eight in ten respondents expressed a willingness to pay a higher average price for products produced locally or domestically.",
      c_date: "2025-01-30",
    },
    {
      blog_id: 4,
      blog_image_url: blog4,
      blog_tags: "Business, Consumers",
      blog_title:
        "Empowered consumers are prepared to make changes response to disruptions!",
      blog_short_txt:
        "Global uncertainties and supply chain issues are also leading many consumers to look more to their home markets. Eight in ten respondents expressed a willingness to pay a higher average price for products produced locally or domestically.",
      c_date: "2025-01-30",
    },
    {
      blog_id: 5,
      blog_image_url: blog5,
      blog_tags: "Business, Consumers",
      blog_title:
        "Empowered consumers are prepared to make changes response to disruptions!",
      blog_short_txt:
        "Global uncertainties and supply chain issues are also leading many consumers to look more to their home markets. Eight in ten respondents expressed a willingness to pay a higher average price for products produced locally or domestically.",
      c_date: "2025-01-30",
    },
    {
      blog_id: 6,
      blog_image_url: blog6,
      blog_tags: "Business, Consumers",
      blog_title:
        "Empowered consumers are prepared to make changes response to disruptions!",
      blog_short_txt:
        "Global uncertainties and supply chain issues are also leading many consumers to look more to their home markets. Eight in ten respondents expressed a willingness to pay a higher average price for products produced locally or domestically.",
      c_date: "2025-01-30",
    },
  ];

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      setLoading(true);
      setError(null);

      const formData = new FormData();
      formData.append("company_id", "1");
      formData.append("employee_id", "1");
      formData.append("type", "1"); // Type 1 for show all blogs

      const response = await fetch(`${api_url}blog.php`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.status === "1" && data.result && data.result.length > 0) {
        setBlogs(data.result);
      } else {
        // Use default blogs if no data found
        setBlogs(defaultBlogPosts);
      }
    } catch (err) {
      console.error("Error fetching blogs:", err);
      setError("Failed to load blogs");
      // Use default blogs on error
      setBlogs(defaultBlogPosts);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Apply background images after blogs are loaded
    if (!loading) {
      const timer = setTimeout(() => {
        document.querySelectorAll(".bg-img")?.forEach((el) => {
          const img = el.querySelector("img");
          if (img) {
            const parent = el.parentElement;
            if (parent) {
              parent.style.backgroundImage = `url(${img.src})`;
              parent.style.backgroundSize = "cover";
              parent.style.backgroundPosition = "center";
              parent.classList.add("bg-img");
              if (el.classList.contains("background-size-auto")) {
                parent.classList.add("background-size-auto");
              }
            }
            el.remove();
          }
        });
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [loading]);

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return "Jan 30, 2025";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  // Parse categories from blog_tags
  const parseCategories = (tags) => {
    if (!tags) return ["Business", "Consumers"];
    return tags.split(",").map((tag) => tag.trim());
  };

  // Use API blogs if available, otherwise use default
  const displayBlogs = blogs.length > 0 ? blogs : defaultBlogPosts;

  return (
    <>
      {/* Page Title Section */}
      <section className="page-title-layout3 page-title-light bg-parallax bg-overlay text-center">
        <div className="bg-img">
          <img src={blogBanner} alt="background" />
        </div>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1 className="pagetitle-heading">Latest News</h1>
              <nav>
                <ol className="breadcrumb justify-content-center mb-0">
                  <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Blog
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </section>

      {/* Blog Posts Section */}
      <section className="blog-layout1">
        <div className="container">
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-3">Loading blogs...</p>
            </div>
          ) : (
            <div className="row">
              {displayBlogs.map((post, index) => (
                <div key={post.blog_id} className="col-sm-6 col-md-6 col-lg-4">
                  <article className="post-item">
                    {/* Post Image */}
                    <div className="post-img">
                      <Link to={`/blog/${post.blog_id}`}>
                        <img
                          src={post.blog_image_url}
                          alt={post.blog_title}
                          loading="lazy"
                          onError={(e) => {
                            // Fallback to default image if API image fails
                            e.target.src =
                              fallbackImages[index % fallbackImages.length];
                          }}
                        />
                      </Link>
                    </div>
                    {/* /.post-img */}

                    {/* Post Body */}
                    <div className="post-body">
                      {/* Categories */}
                      <div className="post-meta-cat">
                        {parseCategories(post.blog_tags).map(
                          (category, catIndex) => (
                            <Link to="#" key={catIndex}>
                              {category}
                            </Link>
                          )
                        )}
                      </div>
                      {/* /.post-meta-cat */}

                      {/* Post Content */}
                      <div className="post-text">
                        <h4 className="post-title mb-0">
                          <Link to={`/blog/${post.blog_id}`}>
                            {post.blog_title || "Untitled Blog Post"}
                          </Link>
                        </h4>
                        <p className="post-desc text-truncate-6 mb-0">
                          {post.blog_short_txt ||
                            "No description available for this blog post."}
                        </p>
                      </div>
                      {/* /.post-text */}

                      {/* Post Date */}
                      <span className="post-meta-date">
                        {formatDate(post.c_date)}
                      </span>
                    </div>
                    {/* /.post-body */}

                    {/* Post Footer */}
                    <div className="post-footer">
                      <Link
                        to={`/blogDetails/${post.blog_id}`}
                        className="btn btn-white"
                      >
                        <i className="icon-arrow-up-right" />
                      </Link>
                    </div>
                    {/* /.post-footer */}
                  </article>
                </div>
              ))}
            </div>
          )}
          {/* /.row */}

          {/* No Blogs Message */}
          {!loading && displayBlogs.length === 0 && (
            <div className="text-center py-5">
              <p className="text-muted">No blogs available at the moment.</p>
            </div>
          )}
        </div>
        {/* /.container */}
      </section>
    </>
  );
}

export default Blogs;
